<script>
import BirimSecimi from "@/router/views/FormComponet/BirimSecimiAnaBirim.vue";
import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import StrRiskBirim from "@/models/StrRiskBirim";
export default {
  mixins: [Api, Sabit, StrRiskBirim],
  props: ["Id", "AddEdit", "Riskid"],
  data() {
    return {
      FormData: {},
      secilen_veriler:[],
    };
  },
  components: {
    Loader,
    BirimSecimi,
  },
  watch: {
    Id() { 
      this.FormData = this.Id;
      if(this.AddEdit == "Add"){  
        this.FormData.Riskid = this.Riskid
      }
    },
    Riskid(){
      if(this.AddEdit == "Add"){  
        this.FormData.Riskid = this.Riskid
      }

    }
  }, 
  methods: {
    onSubmit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        if (this.FormData.Birimids[0] == 1) {
          this.FormData.Birimids.splice(0, 1);
        }
        if (this.AddEdit == "Add") {
          this.Post("StrRiskBirim", this.FormData).then((res)=>{
              if (res) {
                this.$emit("TableUpdate");
                  this.$bvModal.hide("StrRiskBirim");
              }
          });
        } else {
          this.Update("StrRiskBirim", this.FormData).then((res) => {
            if (res) {
              this.$emit("TableUpdate");
              this.$bvModal.hide("StrRiskBirim");
            }
          });
        }
      }
    },
    Get() {},

    Secilmis_Idler(veriler) {
     
      this.secilen_veriler=veriler;

      this.FormData.Birimids = [];
      if (this.secilen_veriler[0] == 1) {
        this.secilen_veriler.splice(0, 1);
      }
    this.FormData.Birimids = this.secilen_veriler;
    }, 
  },
};
</script>
<template>
  <Loader>
    <b-modal
      id="StrRiskBirim"
      size="lg"
      :title="
        this.AddEdit == 'Edit'
          ? $t('StrRiskBirim.AddEdit.FormTitleEdit')
          : $t('StrRiskBirim.AddEdit.FormTitleAdd')
      "
      title-class="font-18"
      hide-footer
    >

      <Form @submit.prevent="onSubmit">  

      <b-form-group
      class="mb-2"
      id="donemler"
      :label="FormDataType.Birimids.FieldTitle"
      label-for="text"
    >
              <BirimSecimi
                :title_position="'mb-3'"
                :selected="FormData.Birimids"
                :labels_lg="'3'"  
                :v="$v.FormData.Birimids"
                :YetkiKontrol="1"
                :multiple="true"
                :BirimTipId="null"
                @Secilmis_Idler="Secilmis_Idler($event)"
              />
          </b-form-group>

        <br>
        <button class="btn btn-primary" type="submit">
          {{ $t("StrRiskBirim.AddEdit.Button") }}
        </button>
      </Form>


    </b-modal>
  </Loader>
</template>
